import { configApiRef, useApi } from '@backstage/core-plugin-api';

export const useBaseUrl = (): string => {
  const config = useApi(configApiRef);
  return config.getString('app.baseUrl');
};

export const agentGardenImageResources = () => {
  return {
    A2AProtocol: {
      url: 'https://backstage-poc-assets-bucket-05d11ec5fa8e174fef3n456e3bfcaf.s3.eu-central-1.amazonaws.com/agent-space/agent-frameworks/type%3Dagent%2Cvariant%3Da2a.avif',
    },
    MCPProtocol: {
      url: 'https://backstage-poc-assets-bucket-05d11ec5fa8e174fef3n456e3bfcaf.s3.eu-central-1.amazonaws.com/agent-space/agent-frameworks/type%3Dagent%2Cvariant%3Dmcp.avif',
    },
    MCPProtocolDark: {
      url: 'https://backstage-poc-assets-bucket-05d11ec5fa8e174fef3n456e3bfcaf.s3.eu-central-1.amazonaws.com/agent-space/agent-frameworks/type%3Dagent%2Cvariant%3Dmcp-darkmode.avif',
    },
    AgentFlow: {
      url: 'https://backstage-poc-assets-bucket-05d11ec5fa8e174fef3n456e3bfcaf.s3.eu-central-1.amazonaws.com/agent-space/agent-frameworks/type%3Dagent%2Cvariant%3Dagentflow.avif',
    },
    AutoGenDark: {
      url: 'https://backstage-poc-assets-bucket-05d11ec5fa8e174fef3n456e3bfcaf.s3.eu-central-1.amazonaws.com/agent-space/agent-frameworks/type%3Dagent%2Cvariant%3Dautogen-dark-mode.avif',
    },
    AutoGenLight: {
      url: 'https://backstage-poc-assets-bucket-05d11ec5fa8e174fef3n456e3bfcaf.s3.eu-central-1.amazonaws.com/agent-space/agent-frameworks/type%3Dagent%2Cvariant%3Dautogen-light-mode.avif',
    },
    'AWS Bedrock': {
      url: 'https://backstage-poc-assets-bucket-05d11ec5fa8e174fef3n456e3bfcaf.s3.eu-central-1.amazonaws.com/agent-space/agent-frameworks/type%3Dagent%2Cvariant%3Daws-bedrock.avif',
    },
    'Microsoft Foundry': {
      url: 'https://backstage-poc-assets-bucket-05d11ec5fa8e174fef3n456e3bfcaf.s3.eu-central-1.amazonaws.com/agent-space/agent-frameworks/type%3Dagent%2Cvarient%3Dms-foundry.avif',
    },
    CrewAI: {
      url: 'https://backstage-poc-assets-bucket-05d11ec5fa8e174fef3n456e3bfcaf.s3.eu-central-1.amazonaws.com/agent-space/agent-frameworks/type%3Dagent%2Cvariant%3Dcrew-ai.avif',
    },
    Databricks: {
      url: 'https://backstage-poc-assets-bucket-05d11ec5fa8e174fef3n456e3bfcaf.s3.eu-central-1.amazonaws.com/agent-space/agent-frameworks/type%3Dagent%2Cvariant%3Ddatabricks.avif',
    },
    'Vertex AI': {
      url: 'https://backstage-poc-assets-bucket-05d11ec5fa8e174fef3n456e3bfcaf.s3.eu-central-1.amazonaws.com/agent-space/agent-frameworks/type%3Dagent%2C%20variant%3Dgcp-vertex-ai-NEW.avif',
    },
    'Google Cloud Platform (GCP)': {
      url: 'https://backstage-poc-assets-bucket-05d11ec5fa8e174fef3n456e3bfcaf.s3.eu-central-1.amazonaws.com/agent-space/agent-frameworks/type%3Dagent%2C%20variant%3Dgeneral-gcp-agent.avif',
    },
    'Cloud Run': {
      url: 'https://backstage-poc-assets-bucket-05d11ec5fa8e174fef3n456e3bfcaf.s3.eu-central-1.amazonaws.com/agent-space/agent-frameworks/type%3Dagent%2C%20variant%3Dgcp-cloud-run.avif',
    },
    Langchain: {
      url: 'https://backstage-poc-assets-bucket-05d11ec5fa8e174fef3n456e3bfcaf.s3.eu-central-1.amazonaws.com/agent-space/agent-frameworks/type%3Dagent%2Cvariant%3Dlangchain.avif',
    },
    'Langchain with Langraph': {
      url: 'https://backstage-poc-assets-bucket-05d11ec5fa8e174fef3n456e3bfcaf.s3.eu-central-1.amazonaws.com/agent-space/agent-frameworks/type%3Dagent%2Cvariant%3Dlanggraph.avif',
    },
    LlamaIndex: {
      url: 'https://backstage-poc-assets-bucket-05d11ec5fa8e174fef3n456e3bfcaf.s3.eu-central-1.amazonaws.com/agent-space/agent-frameworks/type%3Dagent%2Cvariant%3Dllamaindex.avif',
    },
    'Microsoft Semantic Kernel': {
      url: 'https://backstage-poc-assets-bucket-05d11ec5fa8e174fef3n456e3bfcaf.s3.eu-central-1.amazonaws.com/agent-space/agent-frameworks/type%3Dagent%2Cvariant%3Dmicrosoft-semantic-kernel.avif',
    },
    n8n: {
      url: 'https://backstage-poc-assets-bucket-05d11ec5fa8e174fef3n456e3bfcaf.s3.eu-central-1.amazonaws.com/agent-space/agent-frameworks/type%3Dagent%2Cvariant%3Dn8n.avif',
    },
    Others: {
      url: 'https://backstage-poc-assets-bucket-05d11ec5fa8e174fef3n456e3bfcaf.s3.eu-central-1.amazonaws.com/agent-space/via-other-systems.avif',
    },
    Default: {
      url: 'https://backstage-poc-assets-bucket-05d11ec5fa8e174fef3n456e3bfcaf.s3.eu-central-1.amazonaws.com/agent-space/via-other-systems.avif',
    },
  };
};

export const agentGardenDocResources = () => {
  return {
    // Terms of Use and Guidelines
    TermsOfUseConsumer: {
      url: 'https://mercedes-benz.ghe.com/mb-ai-ecosystem/gear-docs/blob/main/AGENT_GARDEN_TOU_CONSUMER.md',
    },
    TermsOfUseProvider: {
      url: 'https://mercedes-benz.ghe.com/mb-ai-ecosystem/gear-docs/blob/main/AGENT_GARDEN_TOU_PROVIDER.md',
    },
    AgentOnboardingGuide: {
      url: 'https://mercedes-benz.ghe.com/mb-ai-ecosystem/gear-docs/blob/main/Agent%20Garden%20Docs.md#onboarding-guide',
    },
    MCPGuidelines: {
      url: 'https://mercedes-benz.ghe.com/mb-ai-ecosystem/gear-docs/blob/main/Guidelines-MCP.pdf',
    },

    // Databricks Resources
    DatabricksEndToEndGuide: {
      url: 'https://learn.microsoft.com/en-us/azure/databricks/generative-ai/agent-framework/build-genai-apps',
    },
    DatabricksAgentCreation: {
      url: 'https://learn.microsoft.com/en-us/azure/databricks/generative-ai/agent-framework/create-agent',
    },
    DatabricksCreateServingEndpoints: {
      url: 'https://learn.microsoft.com/en-us/azure/databricks/machine-learning/model-serving/create-manage-serving-endpoints',
    },
    DatabricksManageServingEndpoints: {
      url: 'https://learn.microsoft.com/en-us/azure/databricks/machine-learning/model-serving/manage-serving-endpoints',
    },
    DatabricksOptimization: {
      url: 'https://learn.microsoft.com/en-us/azure/databricks/machine-learning/model-serving/production-optimization',
    },
    DatabricksDeploymentOptions: {
      url: 'https://mercedes-benz.ghe.com/mb-ai-ecosystem/gear-docs/blob/main/Guidelines-Databricks-Genie.md',
    },
    DatabricksExpectationsLimitations: {
      url: 'https://learn.microsoft.com/en-us/azure/databricks/machine-learning/model-serving/custom-models#expectations-and-limitations',
    },
    DatabricksServingEndpoints: {
      url: 'https://mercedes-benz.ghe.com/mb-ai-ecosystem/gear-docs/blob/main/Agent%20Garden%20Docs.md#databricks',
    },
    DatabricksHowToGetStarted: {
      url: 'https://mercedes-benz.ghe.com/mb-ai-ecosystem/gear-docs/blob/main/Agent%20Garden%20Docs.md#accessing-databricks-hosted-agents',
    },
    DatabricksHostedAgentRequestAccess: {
      url: 'https://mercedes-benz.ghe.com/mb-ai-ecosystem/gear-docs/blob/main/Agent%20Garden%20Docs.md#accessing-databricks-hosted-agents',
    },
    DatabricksHostedAgentAccess: {
      url: 'https://mercedes-benz.ghe.com/mb-ai-ecosystem/gear-docs/blob/main/Agent%20Garden%20Docs.md#accessing-databricks-hosted-agents',
    },
    AgenticSecurityGuidelines: {
      url: 'https://mercedes-benz.ghe.com/mb-ai-ecosystem/gear-docs/blob/main/Agent%20Garden%20Docs.md#security-guidelines',
    },
    AISecurity: {
      url: 'https://www.databricks.com/trust/ai-security',
    },

    // Google Vertex AI Resources
    VertexAIGuide: {
      url: 'https://mercedes-benz.ghe.com/mb-ai-ecosystem/gear-docs/blob/main/Agent%20Garden%20Docs.md#vertex-ai',
    },
    VertexAIProductOverview: {
      url: 'https://cloud.google.com/products/agent-builder?utm_source=google&utm_medium=cpc&utm_campaign=Cloud-SS-DR-GCP-1713664-GCP-DR-APAC-SG-en-Google-BKWS-BRO-Super_simplified&utm_content=c-Hybrid+%7C+BKWS+-+BRO+%7C+Txt+-+AIML-Generative+AI-Vertex+AI-SG_en-1428634164909&utm_term=google%20cloud%20vertex%20ai&gclsrc=aw.ds&gad_source=1&gad_campaignid=23457039093&gclid=Cj0KCQjwgr_NBhDFARIsAHiUWr74MUzyWHVpAwfdDp8oGO8yzHNnOHG4eRN6eKu0Wkoq31cR38YCA4caAvSXEALw_wcB#build-scale-and-govern-your-enterprise-grade-ai-agents',
    },
    VertexAISetupGuide: {
      url: 'https://docs.cloud.google.com/agent-builder/agent-engine/quickstart-adk',
    },
    VertexAIConfigure: {
      url: 'https://docs.cloud.google.com/agent-builder/agent-engine/set-up',
    },
    VertexAIDevelop: {
      url: 'https://docs.cloud.google.com/agent-builder/agent-engine/develop/overview',
    },
    VertexAIAgent2Agent: {
      url: 'https://docs.cloud.google.com/agent-builder/agent-engine/develop/a2a',
    },

    // Google Cloud Run Resources
    CloudRunEssentials: {
      url: 'https://docs.cloud.google.com/run/docs/overview/what-is-cloud-run',
    },
    CloudRunEvaluate: {
      url: 'https://docs.cloud.google.com/run/docs/fit-for-run',
    },
    CloudRunQuickstartGuide: {
      url: 'https://docs.cloud.google.com/run/docs/quickstarts',
    },
    CloudRunEnvironmentSetup: {
      url: 'https://docs.cloud.google.com/run/docs/setup',
    },
    CloudRunOnboardingGuide: {
      url: 'https://mercedes-benz.ghe.com/mb-ai-ecosystem/gear-docs/blob/main/Agent%20Garden%20Docs.md#cloud-run',
    },

    // Google Cloud Platform (GCP) Resources
    GoogleCloudPlatformA2AProtocol: {
      url: 'https://a2a-protocol.org/latest/tutorials/',
    },
    GoogleCloudPlatformWrappingADKWithA2A: {
      url: 'https://google.github.io/adk-docs/a2a/',
    },

    // Microsoft Foundry Resources
    MicrosoftFoundryOnboardingGuide: {
      url: 'https://mercedes-benz.ghe.com/mb-ai-ecosystem/gear-docs/blob/main/Agent%20Garden%20Docs.md#microsoft-foundry',
    },
    MicrosoftFoundryProductOverview: {
      url: 'https://learn.microsoft.com/en-sg/azure/foundry/agents/overview',
    },
    MicrosoftFoundryQuickstartGuide: {
      url: 'https://learn.microsoft.com/azure/foundry/quickstarts/get-started-code',
    },
    MicrosoftFoundryAgentDevelopmentLifecycle: {
      url: 'https://learn.microsoft.com/azure/foundry/agents/concepts/development-lifecycle',
    },
    MicrosoftFoundryAdditionalResources: {
      url: 'https://mercedes-benz.ghe.com/mb-ai-ecosystem/gear-docs/blob/main/Guidelines-MS-Foundry.md',
    },

    // Agent Gateway Resources
    AgentGatewayHowToGetStarted: {
      url: 'https://mercedes-benz.ghe.com/mb-ai-ecosystem/gear-docs/blob/main/Agent%20Garden%20Docs.md#accessing-the-agent-gateway',
    },
    AgentGatewayDiscover: {
      url: 'https://mercedes-benz.ghe.com/mb-ai-ecosystem/gear-docs/blob/main/Agent%20Garden%20Docs.md#accessing-the-agent-gateway-for-vertex-ai-cloud-run-microsoft-foundry',
    },
    AgentGatewayAccess: {
      url: 'https://mercedes-benz.ghe.com/mb-ai-ecosystem/gear-docs/blob/main/Agent%20Garden%20Docs.md#accessing-the-agent-gateway-for-vertex-ai-cloud-run-microsoft-foundry',
    },
    GenerateIamClientId: {
      url: 'https://iamat.iam.corpintra.net/iamat',
    },
    AgentGatewayOneAPI: {
      url: 'https://developer.corpinter.net/apis/aieagentgateway/v1/details',
    },

    // Universal Agent Resources
    UniversalAgentAliceRole: {
      url: 'https://alice.mercedes-benz.com/access/access-request',
    },

    // n8n Resources
    N8nOnboardingGuide: {
      url: 'https://mercedes-benz.ghe.com/mb-ai-ecosystem/gear-docs/blob/main/Agent%20Garden%20Docs.md#n8n',
    },
    N8nWebhookSetupGuide: {
      url: 'https://docs.n8n.io/integrations/builtin/core-nodes/n8n-nodes-base.webhook/',
    },
    N8nAuthenticationGuide: {
      url: 'https://docs.n8n.io/api/authentication/',
    },

    // A2A Resources
    A2AOnboardingGuide: {
      url: 'https://mercedes-benz.ghe.com/mb-ai-ecosystem/gear-docs/blob/main/Agent%20Garden%20Docs.md#a2a',
    },
    A2AFundamentals: {
      url: 'https://a2a-protocol.org/latest/tutorials/',
    },
    A2AADKit: {
      url: 'https://adk.dev/a2a/',
    },

    // MCP Resources
    MCPOnboardingGuide: {
      url: 'https://modelcontextprotocol.io/docs/2026-07-28/getting-started/intro',
    },
    MCPOnboardingAlternativeGuide: {
      url: 'https://mercedes-benz.ghe.com/mb-ai-ecosystem/gear-docs/blob/main/Agent%20Garden%20Docs.md#mcp',
    },
    MCPClientsGuide: {
      url: 'https://modelcontextprotocol.io/docs/2026-07-28/learn/client-concepts',
    },
    MCPAgentSkillsGuide: {
      url: 'https://modelcontextprotocol.io/docs/2026-07-28/develop/build-with-agent-skills',
    },
    MCPIntegrationGuide: {
      url: 'https://learn.microsoft.com/en-us/agent-framework/agents/tools/local-mcp-tools?utm_source=chatgpt.com&pivots=programming-language-csharp',
    },

    // Access Review Resources
    EnterpriseAgents: {
      url: 'https://mercedes-benz.ghe.com/mb-ai-ecosystem/gear-docs/blob/main/Agent%20Garden%20Docs.md#steps-for-enterprise-agents',
    },
    UniversalAgents: {
      url: 'https://mercedes-benz.ghe.com/mb-ai-ecosystem/gear-docs/blob/main/Agent%20Garden%20Docs.md#steps-for-universal-agents',
    },
  };
};

export const useAgentGardenWebResources = () => {
  const baseUrl = useBaseUrl();

  return {
    // Databricks
    DatabricksEditTemplate: {
      url: `${baseUrl}/create/templates/default/agent-editing-databricks-template`,
      urlWithoutBase:
        '/create/templates/default/agent-editing-databricks-template',
    },
    DatabricksOnboardingTemplate: {
      url: `${baseUrl}/create/templates/default/agent-onboarding-databricks-template`,
    },

    // Google Cloud Platform
    GoogleCloudPlatformEditTemplate: {
      url: `${baseUrl}/create/templates/default/agent-editing-google-cloud-platform-template`,
      urlWithoutBase:
        '/create/templates/default/agent-editing-google-cloud-platform-template',
    },
    GoogleCloudPlatformOnboardingTemplate: {
      url: `${baseUrl}/create/templates/default/agent-onboarding-google-cloud-platform-template`,
    },

    // Microsoft Foundry
    MicrosoftFoundryOnboardingTemplate: {
      url: `${baseUrl}/create/templates/default/agent-onboarding-azure-microsoft-foundry-template`,
    },
    MicrosoftFoundryEditTemplate: {
      url: `${baseUrl}/create/templates/default/agent-editing-azure-microsoft-foundry-template`,
      urlWithoutBase:
        '/create/templates/default/agent-editing-azure-microsoft-foundry-template',
    },

    // Universal Resources
    UniversalAgentOnboardingTemplate: {
      url: `${baseUrl}/create/templates/default/agent-onboarding-universal-template`,
    },
    UniversalAgentEditTemplate: {
      url: `${baseUrl}/create/templates/default/agent-editing-universal-template`,
      urlWithoutBase:
        '/create/templates/default/agent-editing-universal-template',
    },

    // n8n Workflow Automation
    n8nOnboardingTemplate: {
      url: `${baseUrl}/create/templates/default/agent-onboarding-n8n-template`,
    },
    n8nEditTemplate: {
      url: `${baseUrl}/create/templates/default/agent-editing-n8n-template`,
      urlWithoutBase: '/create/templates/default/agent-editing-n8n-template',
    },

    // A2A Resources
    A2AAgentOnboardingTemplate: {
      url: `${baseUrl}/create/templates/default/agent-onboarding-a2a-template`,
    },
    A2AAgentEditTemplate: {
      url: `${baseUrl}/create/templates/default/agent-editing-a2a-template`,
      urlWithoutBase: '/create/templates/default/agent-editing-a2a-template',
    },

    // MCP Resources
    MCPAgentOnboardingTemplate: {
      url: `${baseUrl}/create/templates/default/agent-onboarding-mcp-template`,
    },
    MCPAgentEditTemplate: {
      url: `${baseUrl}/create/templates/default/agent-editing-mcp-template`,
      urlWithoutBase: '/create/templates/default/agent-editing-mcp-template',
    },

    // Agent Garden
    AgentGarden: {
      url: `${baseUrl}/aiecosystem/agentgarden`,
    },

    // MCP Garden
    MCPServerOnboardingTemplate: {
      url: `${baseUrl}/create/templates/default/mcp-server-onboarding-template`,
      urlWithoutBase:
        '/create/templates/default/mcp-server-onboarding-template',
    },
    MCPServerEditingTemplate: {
      url: `${baseUrl}/create/templates/default/mcp-server-editing-template`,
      urlWithoutBase: '/create/templates/default/mcp-server-editing-template',
    },
  };
};
